import type {
  AppointmentRequestFlags,
  CustomAppointmentOption,
  CustomAppointmentPreference,
} from "@physiofit-digital/physiofit_types";

export const enabledCustomOptions = (options: CustomAppointmentOption[]) =>
  options.filter((option) => option.enabled && option.name.trim());

export const showsDetailOptions = (
  flags: AppointmentRequestFlags | undefined,
  customOptions: CustomAppointmentOption[],
) =>
  !flags?.hideTherapistPreferences ||
  !flags?.hideHouseVisits ||
  !flags?.hideExtendedTime ||
  !flags?.hideTherapistGenderPreference ||
  enabledCustomOptions(customOptions).length > 0;

// The selection is persisted, so it can outlive an option the practice has since disabled or deleted.
export const customPreferencesToSend = (
  selectedIds: string[],
  customOptions: CustomAppointmentOption[],
): CustomAppointmentPreference[] =>
  enabledCustomOptions(customOptions)
    .filter((option) => selectedIds.includes(option.optionId))
    .map((option) => ({ optionId: option.optionId, name: option.name }));
